/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MehrarbeitAuszahlungDto } from '../../models/mehrarbeit-auszahlung-dto';

export interface GetAllMehrarbeitAuszahlungen$Json$Params {
  date?: string;
  mitarbeiterId?: string;
}

export function getAllMehrarbeitAuszahlungen$Json(http: HttpClient, rootUrl: string, params?: GetAllMehrarbeitAuszahlungen$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MehrarbeitAuszahlungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMehrarbeitAuszahlungen$Json.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MehrarbeitAuszahlungDto>>;
    })
  );
}

getAllMehrarbeitAuszahlungen$Json.PATH = '/v1/mehrarbeitauszahlung';
